import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "vant/lib/index.css";
import "@/assets/styles/index.less";

window.app=createApp(App);
window.app.use(store).use(router).mount('#app')
